module.exports = __webpack_public_path__ + "media/images/web_suite/dashboard/vb_suite_icon_256-0d22432df0d820cfd78e921926c72262.png";